import BulkForm from "./BulkForm"
import BulkFormActions from "./BulkFormActions"
import BulkFormTable from "./BulkFormTable"
import BulkFormRemoveCell from "./BulkFormRemoveCell"
import BulkFormFooter from "./BulkFormFooter"
import BulkFormPasteSlot from "./BulkFormPasteSlot"

export type { BulkFormActionsProps } from "./BulkFormActions"
export type { BulkFormTableProps } from "./BulkFormTable"
export type { BulkFormRemoveCellProps } from "./BulkFormRemoveCell"
export type { BulkFormFooterProps } from "./BulkFormFooter"
export type { BulkFormPasteSlotProps } from "./BulkFormPasteSlot"

export type { BulkRowsOptions } from "./bulkForm.hooks"
import type { BulkRowBase } from "./bulkForm.hooks"
export type { BulkRowBase, BulkRow } from "./bulkForm.hooks"
export { useBulkRows } from "./bulkForm.hooks"

export type BulkFormProps<T extends BulkRowBase> = {
  rows: T[]
  onUpdateRow<K extends keyof T>(index: number, field: K, value: T[K]): void
  onRemoveRow(index: number): void
}

export default Object.assign(BulkForm, {
  Actions: BulkFormActions,
  Table: BulkFormTable,
  RemoveCell: BulkFormRemoveCell,
  Footer: BulkFormFooter,
  PasteSlot: BulkFormPasteSlot,
})
